/** Query keys preserved when linking from My Pages (avoid forwarding unrelated params). */
const MY_PAGES_FILTER_QUERY_KEYS = ['filters', 'filterGroups'] as const;

export function buildMyPagesLinkSearch(currentSearch: string): string {
  if (!currentSearch) return '';
  const params = new URLSearchParams(
    currentSearch.startsWith('?') ? currentSearch.slice(1) : currentSearch
  );
  const next = new URLSearchParams();
  for (const key of MY_PAGES_FILTER_QUERY_KEYS) {
    const value = params.get(key);
    if (value !== null) {
      next.set(key, value);
    }
  }
  const qs = next.toString();
  return qs === '' ? '' : `?${qs}`;
}
